import { ChangeDetectionStrategy, Component, Input, OnChanges, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getAllRouteData } from '../../../lib/get-all-route-data';
import { StoryblokService } from '../../../services/storyblok.service';
import { StoryblokRichTextPipe } from '../../storyblok-rich-text.pipe';
import { StoryblokImage, StoryblokLink } from '../../storyblok-types';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

export interface Review {
  stars: string[];
  text: string;
  reviewerAvatar: StoryblokImage;
  reviewerName: string;
  reviewerRole: string;
  reviewerCompany: string;
  source: StoryblokLink;
  link: string;
  _editable: string;
}

@Component({
  selector: 'app-review-list',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BlockWrapperComponent, StoryblokDirective, StoryblokRichTextPipe],
  templateUrl: './review-list.component.html',
  styleUrl: './review-list.component.scss',
})
export class ReviewListComponent implements OnChanges {
  private route = inject(ActivatedRoute);
  private storyblokService = inject(StoryblokService);
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() style: BlockStyle[];

  @Input() reviewStyle: string;
  @Input() reviews: { review: string; _editable: string; rating: string }[];
  @Input() reviewData: Review[];

  ngOnChanges(): void {
    const data = getAllRouteData(this.route.snapshot);
    const relationships = data.relationships;
    this.reviewData = this.reviews
      .map(review => {
        const relationship = relationships.find(r => r.uuid === review.review)?.content;
        if (!relationship) return;
        return {
          ...relationship,
          _editable: review._editable,
          stars: this.getStars(Number(relationship.rating)),
          link: this.storyblokService.getUrlLink(relationship.source),
        };
      })
      .filter(Boolean);
  }

  getStars(stars: number) {
    const count = Number(stars) || 0;
    return Array(5)
      .fill(0)
      .map((_, i) => {
        const _i = i + 1;
        if (_i >= count + 1) return 'star-empty';
        if (_i <= count) return 'star-filled';
        return 'star-half';
      });
  }
}
